import { render, staticRenderFns } from "./NClientesOverride.vue?vue&type=template&id=a4ed3936&"
import script from "./NClientesOverride.vue?vue&type=script&lang=js&"
export * from "./NClientesOverride.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports